import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SharedService } from 'src/services/shared-service/shared.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const sharedService = inject(SharedService);
  const router = inject(Router);

  const requiredSlug = route.data?.['slug'];  

  if (sharedService.hasPermission(requiredSlug)) {
    return true;
  }

  // User is authenticated (AuthenticationGuard already ran) but lacks
  // permission for this route — send them back to home, not to login.
  // Redirecting to /login here would briefly render the login screen before
  // LoginComponent's own "already authenticated" check bounces to /home.
  // Guard against a redirect loop in the (unexpected) case 'home' itself is denied.
  return router.parseUrl(requiredSlug === 'home' ? '/login' : '/home');
};
